module.exports = __webpack_public_path__ + "img/tree2.91d0ab51.svg";